export const INBOX_DISCLOSURE_VERSION = 1;
export const PRIVACY_URL = "https://www.growmyx.com/privacy";
export const TERMS_URL = "https://www.growmyx.com/terms";

export interface InboxSyncConsent {
  disclosureVersion: number;
  inboxSync: boolean;
  acceptedAt: number | null;
  revokedAt: number | null;
}

export function hasInboxSyncConsent(value: unknown): value is InboxSyncConsent {
  if (!value || typeof value !== "object") return false;
  const state = value as Partial<InboxSyncConsent>;
  return state.disclosureVersion === INBOX_DISCLOSURE_VERSION && state.inboxSync === true
    && typeof state.acceptedAt === "number" && Number.isFinite(state.acceptedAt) && state.acceptedAt > 0
    && state.revokedAt === null;
}

export const INBOX_DISCLOSURE = {
  collection: "Inbox sync copies X conversation participants, profile details, message text and metadata, including recent thread history, through Grow My X's Cloudflare API into your account in Supabase. It powers your CRM inbox, reply detection, and enabled auto-replies.",
  ai: "When you use AI features, relevant message, comment or profile content and your brand voice are sent to our configured AI provider: Anthropic or OpenRouter. Message attachments are represented by the text and metadata X provides; inbox sync does not copy their binary files. If you turn on photo analysis in the Autoresponder, photos people send you are copied to Grow My X's storage for up to 90 days and sent to your AI provider to be described.",
  pause: "Turning automation off or pausing it stops automated X writes. Approved inbox sync can continue, including while paused. Turn inbox sync off here to stop new inbox collection; already-sent requests may finish. Existing saved data stays in your account, and enabled features can still use it. Disable those features to stop that processing, or request deletion using the Privacy Policy.",
  migration: "Inbox sync waits for your choice, including if you used an earlier Grow My X version. Your existing contacts, notes and campaigns remain available. Until sync is enabled, new DM-based reply detection and auto-replies will not update.",
  choice: "I allow inbox sync for the purposes described above.",
} as const;
